import React from 'react'
import TruckIcon from '@material-ui/icons/LocalShippingRounded'
import ToolTip from '../../UI/ToolTip'
import { TopBarSection, TopBar, Widget, WidgetContent } from '@duik/it'
import DoughnutGraph from './DoughnutGraph'

export type Props = {
  projectNumber: string
  projectName: string
  chartInfo: {
    type: string
    data: [number]
    labels: [string]
  }
  history: {
    push: (path: string) => void
  }
}

const ProjectCard = ({ projectNumber, projectName, chartInfo, history }: Props) => {
  const { labels, data } = chartInfo
  return (
    <Widget style={{ minHeight: '463px', maxWidth: '500px' }}>
      <TopBar>
        <TopBarSection style={{ color: '#3e3f42' }}>{projectName}</TopBarSection>
        <TopBarSection>
          <ToolTip title="Hauls">
            <TruckIcon
              className="actionsIcon"
              onClick={() => {
                history.push(`/app/dashboard/${projectNumber}/hauls`)
              }}
            />
          </ToolTip>
        </TopBarSection>
      </TopBar>
      <WidgetContent>
        {data.length ? (
          <DoughnutGraph labels={labels} data={data} />
        ) : (
          <span style={{ fontStyle: 'italic' }}>No trips completed for any haul</span>
        )}
      </WidgetContent>
    </Widget>
  )
}

export default ProjectCard
